if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cartDrawer = document.querySelector('cart-drawer');
        this.cartItems = document.querySelector('cart-items');
        this.cartNotification = document.querySelector('cart-notification');
        this.submitButton = this.querySelector('[type="submit"]');
        this.ctaButton = !this.closest('.section-featured-product') ?
          this.closest('.section')?.querySelector('.sticky-cta .button') : null;

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        if (this.ctaButton) {
          this.ctaButtonListener = this.ctaButtonListener || this.ctaButtonClickHandler.bind(this);
          this.ctaButton.addEventListener('click', this.ctaButtonListener);
        }
      }

      disconnectedCallback() {
        if (this.ctaButton) {
          this.ctaButton.removeEventListener('click', this.ctaButtonListener);
        }
      }

      ctaButtonClickHandler() {
        if (this.submitButton && this.submitButton.classList.contains('product-form__submit')) {
          this.submitButton.click();
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner')?.classList.remove('hidden');

        if (this.ctaButton) {
          this.ctaButton.setAttribute('aria-disabled', true);
          this.ctaButton.querySelector('.loading__spinner')?.classList.remove('hidden');
          this.ctaButton.classList.add('loading');
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const fieldsToCheck = [
          'properties[_trade_in_details]',
          'properties[_trade_in_amount]',
          'properties[_quotation_id]',
          'properties[_trade_in_enabled]',
          'properties[_trade_in_shipping]',
          'properties[_trade_in_shipping_eligible]',
        ];

        fieldsToCheck.forEach((name) => {
          const value = formData.get(name);

          if (value === null || value === '' || value === undefined) {
            formData.delete(name);
          }
        });

        // The trade-in popup already skips the postcode step on a shipping-denied product, but
        // that is UI only - it decides which step renders, nothing re-checks the product when the
        // properties are actually written. This is the single place every trade-in add-to-cart
        // passes through, so the tag verdict is re-read here and a pickup-only product can never
        // carry _trade_in_shipping: true into the cart, whatever the popup left behind.
        if (document.getElementById('tradein')?.dataset.shippingDenied === 'true') {
          if (formData.has('properties[_trade_in_shipping]')) {
            formData.set('properties[_trade_in_shipping]', 'false');
          }
          if (formData.has('properties[_trade_in_shipping_eligible]')) {
            formData.set('properties[_trade_in_shipping_eligible]', 'false');
          }
        }
        // Get all the sections that need to be re-rendered
        let sections = [];
        if (this.cartDrawer) {
          sections = this.cartDrawer.getSectionsToRender().map((section) => section.id);
        }
        if (this.cartNotification) {
          const cartNotificationSections = this.cartNotification.getSectionsToRender().map((section) => section.id);
          sections = [...sections, ...cartNotificationSections];
        }
        if (this.cartItems) {
          const cartItemsSections = this.cartItems.getSectionsToRender().map((section) => section.section);
          sections = [...sections, ...cartItemsSections];
        }
        const mainProperties = {};
        if (document.getElementById('telco')?.checked) {
          mainProperties['Sign up with Maxis Postpaid Plan?'] = 'Yes';
        }
        Object.entries(mainProperties).forEach(([key, value]) => {
          formData.append(`properties[${key}]`, value);
        });
        if (sections.length > 0) {
          formData.append('sections', [...new Set(sections)]);
          formData.append('sections_url', window.location.pathname);

          if (theme.settings.cartDrawer.atcAction === 'drawer' && this.cartDrawer) {
           this.cartDrawer.setActiveElement(document.activeElement);
          } else if (theme.settings.cartDrawer.atcAction === 'notification' && this.cartNotification) {
            this.cartNotification.setActiveElement(document.activeElement);
          }
        }

        config.body = formData;
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              if (this.cartDrawer) this.cartDrawer.reload();

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              if (this.ctaButton) {
                this.ctaButton.setAttribute('aria-disabled', true);
                this.ctaButton.querySelector('span').classList.add('hidden');
              }
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (theme.settings.cartDrawer.atcAction === 'page') {
              window.location = window.routes.cart_url;
              return;
            }

            if (response.sections === null && document.querySelector('.section-main-cart')) {
              window.location.reload();
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    if (this.cartDrawer) this.cartDrawer.renderContents(response);
                    if (this.cartItems) this.cartItems.renderContents(response);
                    if (this.cartNotification) this.cartNotification.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              if (this.cartDrawer) this.cartDrawer.renderContents(response);
              if (this.cartItems) this.cartItems.renderContents(response);
              if (this.cartNotification) this.cartNotification.renderContents(response);
            }
            this.setCartAttributesTradeIn();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cartDrawer && this.cartDrawer.classList.contains('is-empty')) this.cartDrawer.classList.remove('is-empty');
            if (this.cartNotification && this.cartNotification.classList.contains('is-empty')) this.cartNotification.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');

            if (this.ctaButton) {
              this.ctaButton.classList.remove('loading');
              if (!this.error) this.ctaButton.removeAttribute('aria-disabled');
              this.ctaButton.querySelector('.loading__spinner')?.classList.add('hidden');
            }
            this.querySelector('.loading__spinner')?.classList.add('hidden');

            publish('quick-buy-action-complete');
          });
      }
      setCartAttributesTradeIn(){
          let trade_in_enable = false;
          let trade_in_details;
          let trade_in_amount;
          let trade_in_quotation_id;
          if(document.querySelector('#trade_in_details')){
              trade_in_details = document.querySelector('#trade_in_details').value
              trade_in_amount = document.querySelector('#trade_in_amount').value
              trade_in_quotation_id = document.querySelector('#trade_in_quotation_id').value
              trade_in_enable = document.querySelector('#trade_in_enable').value
          }
        if(trade_in_enable) {
          console.log('update cart attributes trade in processing')
          let attributes = {
            "_trade_in_amount": trade_in_amount,
            "_quotation_id": trade_in_quotation_id
          }
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              attributes: attributes
            })
          })
          .then(response => {
            return response.json();
          })
          .finally(() => {
            const trade_in_details_el = document.querySelector('#trade_in_details')
            const trade_in_amount_el = document.querySelector('#trade_in_amount')
            const trade_in_quotation_id_el = document.querySelector('#trade_in_quotation_id')
            const trade_in_enable_el = document.querySelector('#trade_in_enable')
            const trade_in_module = document.querySelector('a[for="start-trade-in"]')
            trade_in_details_el.value = ''
            trade_in_amount_el.value = ''
            trade_in_quotation_id_el.value = ''
            trade_in_enable_el.value = ''
            // Cleared with the rest, or the next plain add-to-cart on this page would carry a
            // leftover _trade_in_shipping and be treated as a trade-in line by the cart sync.
            const trade_in_shipping_el = document.querySelector('#trade_in_shipping')
            const trade_in_shipping_eligible_el = document.querySelector('#trade_in_shipping_eligible')
            if (trade_in_shipping_el) trade_in_shipping_el.value = ''
            if (trade_in_shipping_eligible_el) trade_in_shipping_eligible_el.value = ''
            trade_in_module.style.display = 'none';
          });
        }
      }
      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;

          // Scroll to the error if needed
          const elementRect = this.errorMessage.getBoundingClientRect();
          const isVisible = elementRect.top >= 0 && elementRect.bottom <= window.innerHeight && elementRect.top >= 100;

          // If the element is not visible or if the top of the element is closer than 100px to the top of the viewport
          if (!isVisible) {
            const topPosition = elementRect.top + window.pageYOffset - 150; // Calculate position with 150px padding

            window.scrollTo({
              top: topPosition,
              behavior: 'smooth'
            });
          }
        }
      }
    }
  );
}
